import Header from "./components/layout/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/pages/Home";
import Faq from "./components/pages/Faq";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import ForPlayer from "./components/pages/ForPlayer";
import Thanks from "./components/pages/Thanks";
import Page404 from "./components/pages/Page404/Page404";
import Legal from "./components/pages/Legal";
import Cookie from "./components/pages/Cookie-Policy";
import ForClub from "./components/pages/ForClub";
import ClubLogin from "./components/pages/ClubLogin";
import GolfCourses from "./components/pages/GolfCourses";
import Payment from "./components/pages/Payment";
import PayConfirmed from "./components/pages/PayConfirm";
import ChangePass from "./components/pages/ChangePass";
import ChangedPass from "./components/pages/ChangedPass";
import AccHome from "./components/pages/AccHome";
import AccClub from "./components/pages/AccClub";
import AccCourses from "./components/pages/AccCourses";
import PayCourses from "./components/pages/Courses_AddCourses";
import Courses_pay from "./components/pages/Courses_PayDetail";
import CoursesPayConfirm from "./components/pages/Courses_PayConfirm";
import CoursesMapping from "./components/pages/Courses_Map_Courses";
import CoursesAlert from "./components/pages/Courses_Alert";
import ClubDetail from "./components/pages/ClubDetail";
import ForgetPassword from "./components/pages/ForgetPassword";
import RenewMembership from "./components/pages/RenewMembership/index";
import ExpiredRenewMembership from "./components/pages/ExpiredAccount/ExpiredAcountIndex";
import RenewPaymentExpired from "./components/pages/ExpiredAccount/ExpiredAcountIndex";
// import PayCardExpired from "./components/pages/ExpiredAccount/PayCardExpired";
// import CheckOutExpired from "./components/pages/RenewMembership/CheckoutForm";
import ProtectedRoute from "./components/pages/ExpiredAccount/ProtectedRoute";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import ExpiredAcc from "./components/pages/ExpiredAcc";
// import LoggedUser from "./components/pages/LoggedUser";
import { isAuthenticated } from "./services/authService";
import PrivacyPolicy from "./components/PrivacyPolicy/Privacy";
import IncidentsLog from "./components/pages/Account-IncidentsLog";
import Billing from "./components/pages/Billing";
import BillingPay from "./components/pages/BillingPay";
import BillingEndedBenifits from "./components/pages/BillingEndedBenifits";
import RenewPayment from "./components/pages/RenewMembership";
// import ScrollToTop from "./utils/ScrollToTop";
import CoursesLiveView from "./components/layout/live-view/CoursesLiveView";
import RenewPayCard from "./components/pages/RenewMembership/RenewPayCard";
import CookieConsentBar from "./components/Cookie Consent/CookieConsentBar";
import Competition from "./components/Competition/Competition";
import AllClubCourses from "./components/pages/AllClubCourses";
import CourseList from "./components/pages/CourseList";
import DeleteAccount from "./components/pages/DeleteAccount";

const isAuth = isAuthenticated();

function App() {
  
  return (
    <Router>
      {/* <ScrollToTop /> */}
      <Header />

      <div className="app__main">
        <Switch>
          <Route exact path="/" component={Home}>
            <Home/>
          </Route>

          <Route exact path="/faq" component={Faq}>
            <Faq/>
          </Route>
          <Route exact path="/about" component={About}>
            <About/>
          </Route>
          <Route exact path="/contact" component={Contact}>
            <Contact/>
          </Route>
          <Route exact path="/for-player">
            <ForPlayer />
          </Route>
          <Route exact path="/thank-you">
            <Thanks />
          </Route>
          <Route exact path="/page404" component={Page404}>
            <Page404 />
          </Route>
          <Route exact path="/legal">
            <Legal />
          </Route>
          <Route exact path="/cookie">
            <Cookie />
          </Route>
          <Route exact path="/for-club">
            <ForClub />
          </Route>

          {/*{*/}
          {/*    !isAuth*/}
          {/*    &&*/}
          <Route exact path="/club-login">
            <ClubLogin />
          </Route>
          {/*}*/}

          <Route exact path="/reset-password">
            <ChangePass />
          </Route>
          {/*<Route exact path="/reset-password/:id" component={ChangePass}/>*/}
          <Route exact path="/changed-password">
            <ChangedPass />
          </Route>

          {/* {isAuth ? (
            <Route exact path="/loged-user-home">
              <AccHome />
            </Route>
          ) : (
            <Route exact path="/loged-user-home">
              <Redirect to="/club-login" />
            </Route>
          )} */}
 <ProtectedRoute exact path="/loged-user-home" component={AccHome} />
          <ProtectedRoute exact path="/renew-payment" component={RenewPayment} />
          <ProtectedRoute exact path="/loged-user-prof" component={AccClub} />
                    <ProtectedRoute exact path="/club-course-list" component={CourseList} />

          <ProtectedRoute exact path="/loged-user-courses" component={AccCourses} />
          <ProtectedRoute exact path="/loged-user-competition" component={Competition} />
          <ProtectedRoute exact path="/courses-payment-detail" component={Courses_pay} />
          <ProtectedRoute exact path="/courses-payment-confirm" component={CoursesPayConfirm} />
          <ProtectedRoute path="/courses-map-courses" component={CoursesMapping} />
          <ProtectedRoute exact path="/courses-live-view" component={CoursesLiveView} />
          <ProtectedRoute exact path="/courses-alert" component={CoursesAlert} />
          <ProtectedRoute exact path="/IncidentsLog" component={IncidentsLog} />
          <ProtectedRoute exact path="/billing" component={Billing} />
          <ProtectedRoute exact path="/billingpay" component={BillingPay} />
          <ProtectedRoute exact path="/billingended" component={BillingEndedBenifits} />
          <ProtectedRoute exact path="/delete-account" component={DeleteAccount} />
          <Route exact path="/expired-account">
            {isAuth ? <ExpiredAcc /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/renew-payment">
            {isAuth ? <RenewPayment /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/expired-renew-payment">
            {isAuth ? (
              <ExpiredRenewMembership />
            ) : (
              <Redirect to="/club-login" />
            )}
          </Route>
          <Route exact path="/acc-expired-renew-payment">
            {isAuth ? <RenewPaymentExpired /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/all-club-courses">
            {isAuth ? <AllClubCourses /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/renew-pay-card">
            {isAuth ? <RenewPayCard /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/loged-user-prof">
            {isAuth ? <AccClub /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/loged-user-courses">
            {isAuth ? <AccCourses /> : <Redirect to="/club-login" />}
          </Route>

          {/*courses detail*/}
          <Route exact path="/courses-add-courses">
            {isAuth ? <PayCourses /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/loged-user-competition">
            {isAuth ? <Competition /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/courses-payment-detail">
            {isAuth ? <Courses_pay /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/courses-payment-confirm">
            {isAuth ? <CoursesPayConfirm /> : <Redirect to="/club-login" />}
          </Route>
          <Route path="/courses-map-courses">
            {isAuth ? <CoursesMapping /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/courses-live-view">
            {isAuth ? <CoursesLiveView /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/courses-alert">
            {isAuth ? <CoursesAlert /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/club-detail">
            <ClubDetail />
          </Route>

          {/*<Route exact path="/logged-user">*/}
          {/*    <LoggedUser/>*/}
          {/*</Route>*/}

          {/*<Route exact path="/club-detail">*/}
          {/*    <ClubDetail/>*/}
          {/*</Route>*/}
          <Route exact path="/golf-courses">
            <GolfCourses />
          </Route>

          <Route exact path="/golf-pay">
            <Payment />
          </Route>
          <Route exact path="/pay-confirm">
            <PayConfirmed />
          </Route>
          <Route exact path="/renew-membership">
            {!isAuth ? <Redirect to="/club-login" /> : <RenewMembership />}
          </Route>
          <Route exact path="/forget-password">
            <ForgetPassword />
          </Route>
          <Route exact path="/privacy">
            <PrivacyPolicy />
          </Route>

          {/*//create indidual auth start*/}
          <Route exact path="/IncidentsLog">
            {isAuth ? <IncidentsLog /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/billing">
            {isAuth ? <Billing /> : <Redirect to="/club-login" />}
          </Route>

          <Route exact path="/billingpay">
            {isAuth ? <BillingPay /> : <Redirect to="/club-login" />}
          </Route>

          <Route exact path="/billingended">
            {isAuth ? <BillingEndedBenifits /> : <Redirect to="/club-login" />}
          </Route>
          <Route exact path="/delete-account">
            {isAuth ? <DeleteAccount /> : <Redirect to="/club-login" />}
          </Route>
          <Redirect to="/page404" />
        </Switch>
      </div>
      <CookieConsentBar />
      <Footer />
    </Router>
  );
}

export default App;
